import { type FC } from "react";
import { useModal } from "react-modal-hook";
import router from "next/router";
import { prepareSampleDocument } from "@/state/server";
import Modal from "../ui/design-system/Modal";
import useFormValidator from "../../hooks/useFormValidator";
import { server } from "../../state";
import { useSampleDocuments } from "./useSampleDocuments";
import { SampleDocumentSelector } from "./SampleDocumentSelector";

interface Props {
  hide(): void;
}

export const useSwitchSampleDocumentsModal = () => {
  const [show, hide] = useModal(
    () => <SwitchSampleDocumentsModal hide={hide} />,
    []
  );
  return { show, hide };
};

type FormData = {
  document_types: string;
};

const SwitchSampleDocumentsModal: FC<Props> = ({ hide }) => {
  const { data: sampleDocuments, error } = useSampleDocuments();
  const form = useFormValidator<FormData>(
    {
      document_types: "",
    },
    {
      document_types: {
        required: true,
        message: "Sample document is required",
      },
    }
  );
  const documentType = server.useDocumentTypeSummary("sample_documents");
  const goldens = documentType?.goldens;
  return (
    <Modal
      hideModal={hide}
      title={"Select sample document"}
      agree={"Get started"}
      onBeforeAgree={form.validateForm}
      onAgree={async () => {
        const url = await prepareSampleDocument(
          form.values.document_types,
          goldens
        );
        await router.push(url);
      }}
    >
      <SampleDocumentSelector
        documentsToExtract={sampleDocuments}
        loading={!sampleDocuments && !error}
        value={form.values.document_types}
        error={form.errors.document_types?.required}
        onChange={(val: string) =>
          form.setFieldValue("document_types", val, true)
        }
      />
    </Modal>
  );
};
